module.exports = __webpack_public_path__ + "static/media/GTBSProjectPrevieww935@1x.5b3d3b39.jpg";